import { fetchHil } from "@/utils";

function createInitialLeasePayload() {
  const referer = sessionStorage.getItem("referer");
  const refererCompany = localStorage.getItem("companyReferer");
  const refererCompanyName = localStorage.getItem("companyRefererName");
  const saleTrigram = referer || "";

  const lease = {
    naturalSubscription: referer === null,
    typeOfEstate: "apartment",
    school: refererCompanyName,
    prescriberId: refererCompany,
    company: refererCompanyName,
    companyId: refererCompany,
    assignees: {
      sale: saleTrigram
    }
  };
  return lease;
}

export async function createInitialLease() {
  const lease = createInitialLeasePayload();
  const response = await fetchHil("/lease", {
    method: "POST",
    body: lease
  });

  if (!response.ok) {
    throw new Error(response.status);
  }

  const body = await response.json();
  return body._id;
}
